import React from "react";
import {
  List,
  // SimpleList,
  Datagrid,
  TextField,
  NumberField,
  BooleanField,
  Pagination,
  Filter,
  TextInput,
  BulkActionsToolbar,
} from "react-admin";

// import ListActions from "./ListActions";
// import { exporter } from "./Exporter";
import { getPageId } from "../../helpers/getPageId";
import {
  useIsEnterprisePlan,
  useIsBusinessPlan,
} from "../../helpers/subscriptionPlan";
import CustomDateField from "../Common/CustomDateField";
import CustomPickerInput from "../OrderItem/CustomPickerInput";
import ListActions from "./ListActions";
import BulkUpdateCategoriesButton from "./BulkUpdateCategoriesButton";

const DefaultFilters = (props) => (
  <Filter {...props}>
    <TextInput label="Label" source="label_contains" alwaysOn />
    <TextInput label="Description" source="description_contains" alwaysOn />
    <CustomPickerInput source="createdAt_gte" label="CreatedAt start" />
    <CustomPickerInput source="createdAt_lte" label="CreatedAt end" />
  </Filter>
);

const BulkActionButtons = (props) => (
  <BulkActionsToolbar selectAllButton={false}>
    <BulkUpdateCategoriesButton {...props} />
  </BulkActionsToolbar>
);

const CategoryList = (props) => {
  const pageId = getPageId();
  const isEnterprisePlan = useIsEnterprisePlan();
  const isBusinessPlan = useIsBusinessPlan();

  return (
    <>
      {isBusinessPlan && !isEnterprisePlan && (
        <h4>Your plan supports only 10 categories. Uptier for more.</h4>
      )}
      {!isBusinessPlan && !isEnterprisePlan && (
        <h4>Your plan supports only 2 categories. Uptier for more.</h4>
      )}
      <List
        {...props}
        actions={<ListActions />}
        //exporter={exporter}
        filter={{ page: pageId }}
        filters={<DefaultFilters />}
        pagination={<Pagination rowsPerPageOptions={[10, 25, 50, 100]} />}
        sort={{ field: "createdAt", order: "DESC" }}
      >
        <Datagrid bulkActionsToolbar={<BulkActionButtons />} rowClick="show">
          <TextField source="label" />
          <TextField source="description" />
          <NumberField source="position" />
          <BooleanField source="allowInWeb" />
          <CustomDateField source="createdAt" showTime />
          <CustomDateField source="updatedAt" showTime />
        </Datagrid>
      </List>
    </>
  );
};

export default CategoryList;
